<script>
  // constants
import parties from '../utils/parties';
import Photos from './Photos.svelte';
import lastNameDict from '../utils/nameDictionary';

import { intcomma } from 'journalize';
import { formatPercent } from '../utils/format.js';

/** @type {string} */
  export let familyName
  /** @type {string} */
  export let givenName
  /** @type {string} */
  export let party
  /** @type {boolean} */
  export let isWinner
  /** @type {boolean} */
  export let isRunoff
  // /** @type {number} */
  // export let numOfwinners
  /** @type {boolean} */
  export let isIncumbent
  /** @type {number} */
  export let votes
  /** @type {number} */
  export let nationalVotes
  /** @type {number} */
  export let totalVotes
  /** @type {number} */
  export let totalNationalVotes
  /** @type {boolean} */
  export let isBallotMeasure
  /** @type {boolean} */
  export let isPresident
  /** @type {boolean} */
  export let hasParties
  /** @type {number | undefined} */
  export let numDecimalsInPercent
  /** @type {boolean} */
  export let face
  /** @type {boolean}*/
  export let hasDroppedOut

  /** @type {import('../types.d').Crosswalk} */
  export let lookup;

  // /** @type {string} **/
  // export let ap_id

  const name = `${givenName} ${lastNameDict(familyName) ?lastNameDict(familyName) : familyName }`;

  /**
   * Text to slugify
   * @param {string} text
   */
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }


  const partyFlag = isBallotMeasure ? familyName.toLowerCase() : party;
  const winnerText =
familyName === 'Yes' ? 'Passed' : familyName === 'No' ? 'Failed' : 'winner';

</script>

{#if face}
  <td class="candidate__cell">
    <div class="candidate__cell-headshot {slugify(name)} {party}"
    class:dropped={hasDroppedOut}>
      <Photos
        name={name}
        src={lookup.jpg || lookup.png}
        avif={lookup.avif}
        webp={lookup.webp}
        {party}
      />
    </div>
  </td>
{/if}
<td class="candidate__cell candidate__cell-bar">
  <!-- MOBILE ONLY STYLE -->
  <div
    class="mobile-only text-uppercase bar {!face ? 'bar-'+party : ''} senate-bar_{slugify(name)}"
  >
    {#if isWinner}
      <div class="candidate__cell-winner candidate__{partyFlag}" aria-label="checkmark, winner"> ✓ </div>
    {/if}
  </div>
  <!-- DESKTOP ONLY STYLE -->
  <div
    class="desktop-only bar {!face ? 'bar-'+party : ''} senate-bar_{slugify(name)}"
  >
    {#if isWinner}
      <div class="candidate__cell-winner candidate__{partyFlag}" aria-label="checkmark, winner"> ✓ </div>
    {/if}
  </div>
</td>
  <!--NAME-->

<th
scope="row"
class="candidate__cell candidate__cell-name"
class:candidate__cell-name-winner={isWinner || isRunoff}
class:dropped={hasDroppedOut}
>
{#if hasDroppedOut}
<span class="candidate__cell-dropped candidate __{partyFlag}">
  Dropped out
</span><br>
{/if}
{#if givenName}{givenName}{/if}
{lastNameDict(familyName)}&nbsp;{#if isIncumbent}
  <span
    class="candidate__cell-incumbent"
    title="Currently holds this office"
    role="img"
    aria-label="incumbent">*</span
  >
{/if}
{#if !isBallotMeasure && hasParties && parties[party]}
  <span class="candidate__cell-name-party">({parties[party] ? parties[party].abbr : party.toUpperCase()})</span>
{/if}
{#if isRunoff}
<span
  class="candidate__cell-runoff candidate__{partyFlag}">
  Runoff
  </span>
{/if}
</th>
{#if !isPresident}
<td
class="candidate__cell candidate__cell-pct {isWinner ? 'text-medium' : ''} text-left"
class:candidate__cell-ballot-measures={isBallotMeasure}
>
{formatPercent(votes, totalVotes, numDecimalsInPercent)}
<span class="candidate__pct-symbol">%</span>
</td>
{/if}
{#if isPresident}
<td
class="candidate__cell candidate__cell-votes text-left pres-total"
class:candidate__cell-ballot-measures={isBallotMeasure}
>
{intcomma(votes)}
</td>
{/if}

{#if !isPresident}
<td
class="candidate__cell candidate__cell-votes text-right"
class:candidate__cell-ballot-measures={isBallotMeasure}
>
{intcomma(votes)}
</td>
{/if}
{#if isPresident}
<td
class="candidate__cell candidate__cell-pct {isWinner ? 'text-medium' : ''} text-left"
class:candidate__cell-ballot-measures={isBallotMeasure}
>
{formatPercent(votes, totalVotes, numDecimalsInPercent)}<span class="candidate__pct-symbol">%</span>
</td>
<td
  class="candidate__cell candidate__cell-pct text-medium text-center border-left"
  class:candidate__cell-ballot-measures={isBallotMeasure}>
  {formatPercent(nationalVotes, totalNationalVotes, numDecimalsInPercent)}<span class="candidate__pct-symbol">%</span>
</td>
{/if}
